export default __webpack_public_path__ + "static/media/cif-ph.be214fae.svg";